import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";


// ✅ Load Super Admin Dashboard
export async function loadSuperAdminDashboardApi() {
  try {
    const fd = new FormData();

    const res = await axios.post(`${apiBaseUrl}dashboardapis/super_admin_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;

  } catch {
    return { status: false };
  }
}
